/* src/app/project-budget/project-budget-add/project-budget-add.component.scss */
form {
  display: flex;
  flex-direction: column;
  flex-basis: 100px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-flow: column;
  align-content: flex-start;
  justify-content: space-between;
}
form span {
  padding-bottom: 0.5em;
  margin-top: 1.5em;
}
form span ::ng-deep .p-dropdown,
form span ::ng-deep .p-calendar {
  width: 100%;
}
/*# sourceMappingURL=project-budget-add.component.css.map */
